export default __webpack_public_path__ + "static/media/pop7.5bfbe4af.jpg";